"use strict";
exports.__esModule = true;
exports.useOutsideClickAndEsc = void 0;
var react_1 = require("react");
/**
 * Assign a ref to an element that you want to detect clicks outside of.
 * @example const ref = useOutsideClickAndEsc(() => alert("You clicked outside!"));
 * <div ref={ref}>Click outside of me!</div>
 * @param callback - The callback to call when the user clicks outside the element or hits Esc.
 */
var useOutsideClickAndEsc = function (callback) {
    var ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        var handleClick = function (event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        var handleEscape = function (event) {
            if (event.key === "Escape") {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        document.addEventListener("keydown", handleEscape);
        return function () {
            document.removeEventListener("click", handleClick, true);
            document.removeEventListener("keydown", handleEscape);
        };
    });
    return ref;
};
exports.useOutsideClickAndEsc = useOutsideClickAndEsc;
